/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
import { MatrixTransform } from "./MatrixTransform";
import { TransformMatrixHelpler } from "./TransformMatrixHelpler";
/**
 * @hidden
 */
var AnimationKeyFrameProperty = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(AnimationKeyFrameProperty, _super);
    function AnimationKeyFrameProperty(a, b) {
        var _this = _super.call(this) || this;
        _this.a = 0;
        _this.b = null;
        _this.a = a;
        _this.d = b;
        return _this;
    }
    Object.defineProperty(AnimationKeyFrameProperty.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.c(a);
            this.b = b;
        },
        enumerable: true,
        configurable: true
    });
    AnimationKeyFrameProperty.prototype.c = function (a) {
        if (this.a == 0) {
            return a;
        }
        switch (this.a) {
            case 14:
                var b = TransformMatrixHelpler.f(a);
                var c = new MatrixTransform();
                c.j = b;
                return c;
        }
        return a;
    };
    AnimationKeyFrameProperty.$t = markType(AnimationKeyFrameProperty, 'AnimationKeyFrameProperty');
    return AnimationKeyFrameProperty;
}(Base));
export { AnimationKeyFrameProperty };
//# sourceMappingURL=AnimationKeyFrameProperty.js.map
